import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './layout/app.layout.component';
import { LoginComponent } from './demo/components/auth/login/login.component';
import { PaymentSuccessComponent } from './demo/components/payment-success/payment-success.component';
import { PaymentFailedComponent } from './demo/components/payment-failed/payment-failed.component';
import { SmeSuccessPageComponent } from './demo/components/sme-success-page/sme-success-page.component';
import { PaymentPageComponent } from './demo/components/payment-page/payment-page.component';
import { PromotionsComponent } from './demo/components/promotions/promotions.component';
import { ClicknpayLookupComponent } from './demo/components/clicknpay-lookup/clicknpay-lookup.component';
import { WhatsappBroadcastsComponent } from './demo/components/whatsapp-broadcasts/whatsapp-broadcasts.component';
import { AuthGuard } from './shared/auth.guard';
import { ReportFvdStockUsageComponent } from './demo/components/face-value-documents/report-fvd-stock-usage/report-fvd-stock-usage.component';
import { ComprehensiveApprovalsComponent } from './demo/components/comprehensive-approvals/comprehensive-approvals.component';
import { ComprehensiveQuoteDetailsComponent } from './demo/components/comprehensive-approvals/comprehensive-quote-details/comprehensive-quote-details.component';
import { BankReconciliationComponent } from './demo/components/bank-reconciliation/bank-reconciliation.component';
import { PosConfigComponent } from './demo/components/bank-reconciliation/pos-config/pos-config.component';
import { BankManagementComponent } from './demo/components/bank-reconciliation/bank-management/bank-management.component';
import { SalesUploadComponent } from './demo/components/bank-reconciliation/sales-upload/sales-upload.component';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                { path: '', component: LoginComponent },
                {
                    path: 'web-purchases',
                    loadChildren: () =>
                        import(
                            './demo/components/web-purchases/web-purchases.module'
                        ).then((m) => m.WebPurchasesModule),
                },
                { path: 'eft-pay', component: PaymentPageComponent },
                {
                    path: 'payment-success',
                    component: PaymentSuccessComponent,
                },
                {
                    path: 'clicknpay-lookup/response/:id',
                    component: ClicknpayLookupComponent,
                },
                {
                    path: 'clicknpay-lookup/response/:id',
                    component: ClicknpayLookupComponent,
                },
                {
                    path: 'clicknpay-lookup/:id',
                    component: ClicknpayLookupComponent,
                },
                {
                    path: 'payment-failed',
                    children: [
                        {
                            path: 'motor',
                            component: PaymentFailedComponent,
                        },
                        {
                            path: 'sme',
                            component: PaymentFailedComponent,
                        },
                    ],
                },
                {
                    path: 'home',
                    component: AppLayoutComponent,
                    children: [
                        {
                            path: '',
                            loadChildren: () =>
                                import(
                                    './demo/modules/customer/customer.module'
                                ).then((m) => m.CustomerModule),
                        },
                        {
                            path: 'partners',
                            loadChildren: () =>
                                import(
                                    './demo/modules/partners/partners.module'
                                ).then((m) => m.PartnersModule),
                        },
                        {
                            path: 'users',
                            loadChildren: () =>
                                import(
                                    './demo/modules/users/users.module'
                                ).then((m) => m.UsersModule),
                        },
                        {
                            path: 'whatsapp-broadcasts',
                            component: WhatsappBroadcastsComponent,
                            canActivate: [AuthGuard],
                        },
                        {
                            path: 'promotions',
                            component: PromotionsComponent,
                        },
                        {
                            path: 'icecash-reports',
                            loadChildren: () =>
                                import(
                                    './demo/modules/icecash-reports/icecash-reports.module'
                                ).then((m) => m.IcecashReportsModule),
                        },
                        {
                            path: 'face-value-documents',
                            loadChildren: () =>
                                import(
                                    './demo/components/face-value-documents/fvd.module'
                                ).then((m) => m.FvdModule),
                        },
                        {
                            path: 'face-value-usages',
                            component: ReportFvdStockUsageComponent,
                        },
                        {
                            path: 'comprehensive-approvals',
                            component: ComprehensiveApprovalsComponent
                        },
                        {
                            path: 'comprehensive-approvals/:id',
                            component: ComprehensiveQuoteDetailsComponent
                        },
                        {
                            path: 'bank-reconciliations',
                            component: BankReconciliationComponent
                        },
                        {
                            path: 'pos-config',
                            component: PosConfigComponent
                        },
                        {
                            path: 'bank-management',
                            component: BankManagementComponent
                        },
                        {
                            path: 'sales-upload',
                            component: SalesUploadComponent
                        }
                    ],
                },
                {
                    path: 'auth',
                    loadChildren: () =>
                        import('./demo/components/auth/auth.module').then(
                            (m) => m.AuthModule
                        ),
                },
                {
                    path: 'password-reset',
                    loadChildren: () =>
                        import(
                            './demo/components/password-reset/password-reset.module'
                        ).then((m) => m.PasswordResetModule),
                },
                { path: '**', redirectTo: '' },
            ],
            {
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled',
                onSameUrlNavigation: 'reload',
            }
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
